import { useQueryClient } from '@tanstack/react-query'
import { Space, Typography } from 'antd'
import React, { type JSX } from 'react'

import { SettingsRow } from '../../../Settings'

import { isThrottlingActive } from './messageLimit'

import { putClient } from 'api/clients'
import { QUERIES } from 'constants/queries'
import { InlineEditField } from 'shared/components/InlineEditField/InlineEditField'
import { Switch } from 'shared/components/Switch'

const formatNumber = (value: any) => value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')

const validateLimit = (value: any) => Boolean(value.match(/^\d{4,}$/)) && Number(value) > 1000

export function MessageLimitRow({ client }: any): JSX.Element {
  const queryClient = useQueryClient()
  return (
    <SettingsRow
      description={`Throttles campaigns after the monthly limit. ${formatNumber(
        client.campaignMessagesMonthlyUsed ?? 0,
      )} campaign messages used this month.`}
      label="Monthly Message Limit"
    >
      <Space>
        <Switch
          defaultChecked={isThrottlingActive(client.campaignMessagesMonthlyThreshold)}
          name="Throttling Active"
          onSuccess={() => queryClient.invalidateQueries([QUERIES.CLIENT, { id: client.id }])}
          prepare={(value) => ({
            id: client.id,
            body: {
              campaign_messages_monthly_threshold: value ? 25001 : 0,
            },
          })}
          updateEntity={putClient}
        />
        {isThrottlingActive(client.campaignMessagesMonthlyThreshold) && (
          <InlineEditField
            defaultValue={formatNumber(client.campaignMessagesMonthlyThreshold)}
            name="Monthly Limit"
            onSuccess={() => queryClient.invalidateQueries([QUERIES.CLIENT, { id: client.id }])}
            prepare={(value) => ({
              id: client.id,
              body: { campaign_messages_monthly_threshold: value },
            })}
            updateEntity={putClient}
            validation={validateLimit}
          >
            {({ valid }: { valid: any }) =>
              isThrottlingActive(client.campaignMessagesMonthlyThreshold) && (
                <Typography.Text type={valid ? 'secondary' : 'danger'}>
                  Provide a value greater than 1,000.
                </Typography.Text>
              )
            }
          </InlineEditField>
        )}
      </Space>
    </SettingsRow>
  )
}
